import qs from 'qs'

import { get, post } from '@/utils/http/http'
import { LIVE_INTERFACE_URL, SUBSCRIBE_URI } from '@/utils/http/baseUrl'

export default {
  postLogin: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/saleLogin`, params),
  postMakeInvitation: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/generateInvitation`, params),
  postClientList: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/queryGuestList`, params),
  postInvitationDetail: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/getFocusState`, params),
  postChanghongQRCode: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/qrCode`, params),
  getSlider: (params) => get(`${SUBSCRIBE_URI}/slidverify/api/v2/code/create`, params),
  postValidateSlider: (params) => post(`${SUBSCRIBE_URI}/slidverify/api/v2/code/verify`, qs.stringify(params), true, { allRes: true }),
  postSendValidateCode: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/code`, params),
  postSignUp: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/submitInvitation`, params),
  postSignUpStatus: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/getInvitationState`, params),
  postLiveLogin: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/liveLogin`, params),
  postCheckChanghong: (params) => post(`${LIVE_INTERFACE_URL}/custom/v1/changhong/reAuthRequired`, params)
}
